import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[#050505] border-t hairline px-6 md:px-12 py-16" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-8 mb-16">
          <div className="col-span-2 md:col-span-6">
            <div className="font-display uppercase text-5xl md:text-7xl font-extrabold tracking-[-0.03em] leading-none">
              HK<span className="text-[color:var(--accent)]">.</span>Brand Lab
            </div>
            <p className="mt-6 max-w-md text-[color:var(--muted)] text-sm md:text-base leading-relaxed font-serif-italic">
              {t.footer.colophon}
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.22em] text-[color:var(--muted)] mb-4">
              {t.footer.studio}
            </div>
            <ul className="space-y-2 text-sm">
              <li>Hong Kong · China</li>
              <li>Dubai · UAE</li>
              <li>Shanghai · China</li>
              <li>Milano · Italy</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.22em] text-[color:var(--muted)] mb-4">
              {t.footer.contact}
            </div>
            <ul className="space-y-2 text-sm">
              <li><a href="mailto:hello@hkbrandlab.com" className="link-hover">hello@hkbrandlab.com</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.22em] text-[color:var(--muted)] mb-4">
              {t.footer.social}
            </div>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="link-hover">Instagram</a></li>
              <li><a href="#" className="link-hover">Behance</a></li>
              <li><a href="#" className="link-hover">LinkedIn</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t hairline flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs uppercase tracking-[0.22em] text-[color:var(--muted)]">
          <div>© {year} HK Brand Lab. {t.footer.rights}</div>
          <div className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 rounded-full bg-[color:var(--accent)] animate-pulse" />
            Available for select projects — 2026
          </div>
        </div>
      </div>
    </footer>
  );
}
